import { jwtDecode } from 'jwt-decode'

import localstorageConstants, {
  getLocalstorage,
  removeLocalstorage
} from './localstorage-manipulation'

export type JWTPayload = {
  user_id: string
  email: string
  name: string
  current_account_id: string
  current_role: UserRoles
  current_account_type: AccountTypes
  publisher_id?: string
  is_network?: string
  /** Advertiser managed by VTEX Ads team — PI create gate. */
  is_managed_by_vtex?: boolean
  iat: number
  exp: number
}

export const getAuthToken = () => getLocalstorage(localstorageConstants.TOKEN)

export const getAppInfo = () => {
  const storageValue = localStorage.getItem(localstorageConstants.APP_INFO)

  if (storageValue) {
    return JSON.parse(storageValue) as AppInfoData
  }

  return null
}

export type GetDecodedToken = () => JWTPayload | Record<string, never>

export const getDecodedToken: GetDecodedToken = () => {
  const token = getAuthToken()

  if (token) {
    return jwtDecode<JWTPayload>(token)
  }
  return {}
}

export const removeAuthToken = () => {
  removeLocalstorage(localstorageConstants.TOKEN)
}

export const getAccountId = () => getDecodedToken()?.current_account_id
export const getIsWhiteLabel = () => !!getDecodedToken()?.publisher_id
export const getIsNetwork = () => !!getDecodedToken()?.is_network
export const getIsManagedByVtex = () =>
  getDecodedToken()?.is_managed_by_vtex === true
export const getWhiteLabelPublisherId = () =>
  getDecodedToken()?.publisher_id as BrandedType<string, 'PublisherId'> | null

export const getAccountType = () =>
  (getDecodedToken()?.current_account_type as 'industry' | 'grocery') ||
  'grocery'

export const getUserId = () => getDecodedToken().user_id

export const getRole = () => getDecodedToken().current_role
export const isAdmin = () => getRole() === 'admin'
export const isReadOnly = () => getRole() === 'read_only'

export const getEmail = () => getDecodedToken().email

/**
 * Retail media
 */
export const getRetailMediaAccountType = () => {
  const accountType = getAccountType()

  type TypesAccount = {
    [key in AccountTypes]: RetailMediaAccountTypes
  }

  const types: TypesAccount = {
    grocery: 'publisher',
    industry: 'advertiser'
  }

  return types[accountType] as RetailMediaAccountTypes
}

export const isAdvertiser = () => getRetailMediaAccountType() === 'advertiser'

export const isPublisher = () => getRetailMediaAccountType() === 'publisher'

export const getRetailMediaCounterpart = () =>
  getRetailMediaAccountType() === 'publisher' ? 'advertiser' : 'publisher'

export const getRetailMediaCounterpartID = () =>
  getRetailMediaAccountType() === 'publisher' ? 'advertiser_id' : 'publisher_id'
